export default {
  status: {
    pending: 'Wacht op DNS',
    verified: 'Live',
    failed: 'Actie nodig',
  },
  summary: {
    preparing:
      'De records voor {{host}} worden voorbereid. Ze verschijnen hier binnen ongeveer 15 minuten — of meteen nadat u op Opnieuw controleren klikt.',
    pending:
      'Wacht op de DNS-records hieronder. Dit duurt meestal een paar minuten en kan tot 48 uur duren — we blijven zelf controleren.',
    certificate_pending:
      'De records staan goed. Het certificaat voor {{host}} wordt uitgegeven — dit duurt meestal een paar minuten.',
    verified: 'De webshop is live op {{host}}.',
    serving: 'De webshop is live op {{serving_host}}, maar {{host}} zelf opent hem nog niet.',
    apex_elsewhere:
      'Het A-record op @ wijst nog niet naar de shop. Toont {{host}} een website die daar moet blijven, laat @ dan zoals het is — de shop werkt op {{serving_host}}. Voeg anders het A-record hieronder toe.',
    apex_held:
      '{{host}} wordt gebruikt door een andere website op Vercel. Wilt u dat {{host}} ook de shop opent, verwijder het domein dan eerst van die website.',
    regressed:
      '{{host}} werkte eerder, maar een record hieronder wordt niet meer bevestigd. Pas het aan bij de DNS-provider en klik daarna op Opnieuw controleren.',
    record_elsewhere:
      'Een record hieronder wijst ergens anders naartoe. Wijzig het bij de DNS-provider in de getoonde waarde en klik daarna op Opnieuw controleren.',
    records_missing:
      'De records hieronder zijn na 48 uur nog steeds niet gevonden. Controleer of ze zijn opgeslagen voor {{zone}}, bij de provider die de DNS ervan beheert. Staat die provider de wijziging niet toe, dan is het domein daar mogelijk vergrendeld.',
    certificate: {
      ownership_proof_required:
        '{{host}} is ook gekoppeld aan een ander Vercel-account, dus moet het restaurant aantonen dat het de eigenaar van het domein is.',
      held_by_another_project:
        '{{host}} wordt nog gebruikt door een andere website op Vercel, dus de shop kan het nog niet gebruiken.',
      dns_correct_but_unconfigured: 'De records kloppen, maar iets anders op {{host}} blokkeert het certificaat.',
      name_mismatch: '{{host}} antwoordt nog met een certificaat voor een andere naam.',
      expired: 'Het certificaat voor {{host}} is verlopen. We zijn gewaarschuwd en zijn ermee bezig.',
      expiring: 'Het certificaat voor {{host}} verloopt binnenkort en is nog niet vernieuwd. We zijn ermee bezig.',
      attach_refused:
        'Onze hostingprovider heeft geweigerd {{host}} aan onze kant toe te voegen. We zijn gewaarschuwd en zijn ermee bezig.',
      overdue: 'Het certificaat voor {{host}} is na 48 uur nog steeds niet uitgegeven.',
      unknown: 'Het certificaat voor {{host}} kon niet worden uitgegeven.',
    },
    certificate_see_row: 'De certificaatregel hieronder vertelt wat u moet doen.',
  },
  instructions: {
    title: '{{host}} koppelen',
    step_provider: 'Log in waar de DNS van {{zone}} wordt beheerd — meestal het bedrijf waar het domein is gekocht.',
    step_add: 'Voeg elk record hieronder precies zo toe als getoond: het type, de naam en de waarde.',
    step_check: 'Sla op en klik daarna op {{button}}. We blijven ook zelf controleren.',
    tip_name:
      'De meeste providers willen in het naamveld alleen het deel vóór {{zone}} — hier {{names}}. De volledige naam staat er ook, voor providers die erom vragen.',
    tip_apex: '@ staat voor {{zone}} zelf. Sommige providers laten de naam daarvoor in plaats daarvan leeg.',
    tip_apex_website:
      'Als {{zone}} al een website opent, haalt u {{zone}} bij die website weg door @ naar de shop te laten wijzen. Wilt u de website daar houden, laat de records op @ dan zoals ze zijn — de shop werkt nog steeds op www.{{zone}} — of koppel in plaats daarvan een subdomein zoals order.{{zone}} aan de shop.',
    tip_existing:
      'Verwijder alle andere A-, AAAA- of CNAME-records op {{name}}. Twee records die naar verschillende plekken wijzen, laten de shop maar soms laden.',
    tip_cloudflare:
      'Zet deze records bij Cloudflare op Alleen DNS (grijze wolk). Met de proxy aan kan niemand zien waar ze naartoe wijzen en kan er geen certificaat worden uitgegeven.',
    tip_locked:
      'Als de provider het toevoegen of wijzigen van deze records niet toestaat, is het domein mogelijk vergrendeld of wordt de DNS ergens anders beheerd. De provider kan het ontgrendelen of zeggen waar de DNS wordt beheerd.',
  },
  records: {
    title: 'Records voor {{host}}',
  },
  separate_domains: {
    apex: 'Dit domein is alleen voor de webshop: de shop gebruikt {{zone}} en www.{{zone}}. Een website heeft een andere naam nodig — een subdomein van {{zone}} of een eigen domein.',
    subdomain: 'Dit domein is alleen voor de webshop. Een website kan {{zone}} of www.{{zone}} gebruiken.',
  },
  load_error: 'De status van het domein kon niet worden geladen.',
  no_access: 'Geen toegang tot de status van het domein van dit restaurant.',
  polling_stopped: 'Deze pagina wordt niet meer vanzelf vernieuwd. Klik op Opnieuw controleren om haar te vernieuwen.',
  buttons: {
    check_again: 'Opnieuw controleren',
    retry: 'Opnieuw proberen',
  },
  toasts: {
    check_started: 'De records worden gecontroleerd. Dit kan een minuut duren.',
    check_failed: 'De controle kon niet worden gestart. Probeer het opnieuw.',
    check_too_soon: 'Zojuist gecontroleerd. Wacht een minuut voordat u opnieuw controleert.',
  },
};
